import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { RELATION_TYPE_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const RelationTypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: RELATION_TYPE_RESOURCE,
      method: 'get',
      request: (id, rejectCallback, t) => ({
        url: apiRoutes.relationTypes(id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getRelationTypeFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RelationTypeService;
